module.exports = __webpack_public_path__ + "img/check-mark.4c88607b.svg";